import { Injectable} from '@angular/core';
import { IContractDataModel, IContractTargetData, INewStep, IRoadMapHistory, IStepDataToOpen, TTargetData } from '../models/contract-internal-models';
import { IStepNameData } from '../../../services/contracts/contract-control.service';
import { BehaviorSubject, map, Observable, Subject } from 'rxjs';
import { ContractModel, ContractRoadmapModel, ContractStepModel, ContractWrapperModel, PaymentTransactionModel_Opt } from '../../../models/contract.model';
import { MemberModel } from '../../../models/user.model';
import { IMultiPaymentStateCS } from '../../../models/finance.model';
import { TFormState } from '../../../models/forms.model';
import { IRestrictionStepOrder } from '../../graph-konva/models/graph-kn.model-interfaces';
import { TContractGraphType } from '../../graph-konva/models/graph-kn.cm-api-models';
import { ContractsService } from '../../../services/api/contracts.service';
@Injectable({
    providedIn: 'root'
})
export class ContractDataService {
  public ContractDataCachedByGuid:Map<string,IContractDataModel> = new Map () 
  public contractTargetData:IContractTargetData[] = []
  public restrictionsPerContract: IRestrictionStepOrder[] = []; // Restrictions to change order of a roadmap
  public targetsWithErrorLoading:string [] = []
  public allMembers: MemberModel[] = [];
  public currentMember:MemberModel|null = null;
  public activeRoadMapClone:ContractRoadmapModel|null = null;
  public isGraphShown:boolean = false // is contract opened in graph mode

  // Subjects
  //Contract States
  public bSubContractDataIsCached:Subject<{guid:string}> = new Subject()
  public subUserPrivilegesSet: Subject<boolean> = new BehaviorSubject<boolean>(false);
  public subAlltargetDataIsLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public subStepDataChanged: Subject<IStepNameData> = new Subject<IStepNameData>();
  public subStepFormCDS: Subject<boolean> = new Subject<boolean>();
  public subContractFormState:BehaviorSubject<TFormState> = new BehaviorSubject('Default' as TFormState)
  public subContractEdited:BehaviorSubject<boolean> = new BehaviorSubject(false) // Contract data has been changed but not saved
  public subContractDeleted:Subject<{guid:string}> = new Subject() // Contract has been deleted from DB
  public subContractCreated:Subject<ContractWrapperModel> = new Subject() // Contract has been created in DB
  public subContractEditedNameOrDesc:Subject<ContractModel> = new Subject() // Contract has been created in DB

  //Instructions to contract
  public subContractReloadContract:BehaviorSubject<boolean> = new BehaviorSubject(false) //Reload contract data
  public subContractDetectChanges:BehaviorSubject<boolean> = new BehaviorSubject(false) //Detect changes using change detection strategy
  public subContractModifiedSaveOrCancel:Subject<boolean> = new Subject() // Save or Abort changes made to the contract

  //Contract rights
  public subContractBlockEdit:BehaviorSubject<boolean> = new BehaviorSubject(false) // Contract is blocked for editing

  //RoadMap Steps
  public subContractStepCreateNew:BehaviorSubject<INewStep> = new BehaviorSubject({action:"none"} as INewStep)
  public subContractStepToOpenOne:Subject<IStepDataToOpen> = new Subject()
  public subStepPreviewPointerCalc:Subject<boolean> = new Subject()
  //RoadMap
  public subRoadMapHistoryListOpened: Subject<boolean> = new Subject()
  public subRoadMapSelected: BehaviorSubject<IRoadMapHistory|{}> = new BehaviorSubject({})
  //Graph
  public contractGraphTypeSub: Subject<TContractGraphType> = new Subject()
  //Navigation
  public bSubContractTableRoute = new BehaviorSubject<string[]|null>(null)

  
  constructor (
    private contractsService:ContractsService
  ) {
    this.contractTargetData.push({
      contractGuid:'',
      targetData: {
        files:[],
        tasks:[],
        payments:[],
        credit_letter:[],
        multi_payments:[],
        sub_contracts:[]
      }
    })
  }
  resetContractTargetData(contractGuid:string) {
    //let indx = this.contractTargetData.findIndex(el=>el.contractGuid === contractGuid)
    let indx = 0
    this.contractTargetData[indx].targetData = {
        files:[],
        tasks:[],
        payments:[],
        credit_letter:[],
        multi_payments:[],
        sub_contracts:[]
    } ;
  }
  getCachedStepTargetData(step:ContractStepModel|null):TTargetData|undefined {
    let targetData = this.contractTargetData[0].targetData
    switch (step?.target_type) {
      case 'file': return targetData.files.find(el=>el.guid===step.target_key)?.data
      case 'task': return targetData.tasks.find(el=>el.guid===step.target_key)?.data
      case 'sub_contract': 
        return targetData.sub_contracts.find(el=>el.guid===step.target_key)?.data
      case 'multi_payment': 
        return targetData.multi_payments.find(el=>el.guid===step.target_key)?.data
      case 'credit_letter':
      case 'general_credit_letter': 
        return targetData.credit_letter.find(el=>el.guid===step.target_key)?.data
      case 'payment':
      case 'direct_payment':
        return targetData.payments.find(el=>el.guid===step.target_key)?.data
      default: return undefined
    }
  } 
  setStepTargetData(step:ContractStepModel,newData?:TTargetData):TTargetData|undefined{
    let targetData = this.contractTargetData[0].targetData
    let targetItem :TTargetData|undefined
    switch (step.target_type) {
      case 'file': return targetData.files.find(el=>el.guid===step.target_key)?.data
      case 'task': return targetData.tasks.find(el=>el.guid===step.target_key)?.data
      case 'sub_contract': 
        return targetData.sub_contracts.find(el=>el.guid===step.target_key)?.data
      case 'multi_payment': 
        newData = newData as IMultiPaymentStateCS 
        targetItem = targetData.multi_payments.find(el=>el.guid===step.target_key)?.data 
        targetItem? targetItem = newData: targetData.multi_payments.push({guid:'',data:newData})
        return targetItem
      case 'credit_letter':
      case 'general_credit_letter': 
        return targetData.credit_letter.find(el=>el.guid===step.target_key)?.data
      case 'payment':
      case 'direct_payment':
        targetItem = targetData.payments.find(el=>el.guid===step.target_key)?.data 
        targetItem? targetItem = newData as PaymentTransactionModel_Opt : null
        return targetItem
      default: return undefined
    }
  } 
    getContractByGuid(guid:string): Observable<ContractWrapperModel> {
      return this.contractsService.getByGuid(guid).pipe(
        map(data=>{
          let stepsWithCL=  data.contract.roadmap_active?.steps?.map(step=>{
            if (step.target_type === 'credit_letter' && step.target) {
              step.target.payer_project = data.contract.projects.find(project => project.credit_letter_guid === step.target_key)
              step.target.payer_private = data.contract.privates.find(person => person.credit_letter_guid === step.target_key)
            }
            return step;
          }
          )
          return {
            ...data.contract, 
            roadmap_active:{
              ...data.contract.roadmap_active,
              steps: stepsWithCL
            } 
            }
        })
      )
    }
}